<template>
    <v-footer fixed :class="['routine-footer', { 'desktop': !isMobile }]">
        <div class="rf-inner">
            <div class="rf-pct">{{ percent }}%</div>
            <div class="rf-bar">
                <div class="rf-fill" :style="{ width: `${percent}%` }" />
            </div>
        </div>
    </v-footer>
</template>

<script>

export default {
    props: {
        percent: {
            type: Number,
            default: 0
        },
    },
}
</script>

<style scoped>
.routine-footer {
    background: var(--v-surface-base) !important;
    border-top: 1px solid var(--v-outline-base);
    z-index: 8;
    padding: 0 20px;
    height: calc(74px + var(--safe-area-inset-bottom, 0px)) !important;
}

.routine-footer.desktop {
    left: 56px !important;
    z-index: 6;
}

.rf-inner {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    margin-bottom: var(--safe-area-inset-bottom, 0px);
}

.rf-pct {
    font-size: 26px;
    font-weight: 800;
    color: var(--v-txtPrimary-base);
    font-variant-numeric: tabular-nums;
    flex-shrink: 0;
}

.rf-bar {
    flex: 1;
    height: 8px;
    border-radius: 4px;
    overflow: hidden;
    background: var(--v-outline-base);
}

.rf-fill {
    height: 100%;
    border-radius: 4px;
    background: linear-gradient(90deg, #CCFF33, #009966);
    transition: width 1.4s cubic-bezier(0.16, 1, 0.3, 1);
}
</style>
